(function (Drupal) {
  Drupal.behaviors.reviewModal = {
    attach: function (context, settings) {
      // once() garantit qu'on attache les listeners une seule fois,
      // même si attach() est rappelé (Ajax, etc.)
      once('review-modal', 'body', context).forEach(function () {
        document.addEventListener('click', function (e) {
          const modal = document.getElementById('reviewModal');
          if (!modal) return;
          const body = modal.querySelector('.js-modal-body');

          if (e.target.classList.contains('js-readmore')) {
            const fullText = e.target.parentElement.querySelector('.js-readmore-full');
            body.textContent = fullText.textContent;
            modal.hidden = false;
            document.body.style.overflow = 'hidden';
          }

          if (e.target.classList.contains('js-modal-close')) {
            modal.hidden = true;
            document.body.style.overflow = '';
          }
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            const modal = document.getElementById('reviewModal');
            if (modal) {
              modal.hidden = true;
              document.body.style.overflow = '';
            }
          }
        });
      });
    }
  };
})(Drupal);